export function generateBaseCSS(): string {
  return `/* ============================================
   COMPONENT STYLES
   Generated by Studio v5.0.0
   ============================================ */

/* Base Reset */
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html {
  scroll-behavior: smooth;
  scroll-padding-top: calc(var(--header-h, 44px) + var(--sp-4));
}
@media (prefers-reduced-motion: reduce) {
  html { scroll-behavior: auto; }
}

body {
  font-family: var(--font-body);
  font-size: var(--text-base);
  line-height: var(--leading-normal);
  color: var(--c-text);
  background: var(--c-bg);
  -webkit-font-smoothing: antialiased;
}

/* Signature Frame (optional: set --edge-width > 0) */
body::before,
body::after {
  content: '';
  position: fixed;
  top: 0;
  bottom: 0;
  width: var(--edge-width, 0px);
  background: linear-gradient(
    180deg,
    var(--edge-color-a, transparent) 0%,
    var(--edge-color-b, transparent) 50%,
    var(--edge-color-a, transparent) 100%
  );
  z-index: 999;
  pointer-events: none;
}
body::before { left: 0; }
body::after { right: 0; }



img { max-width: 100%; height: auto; display: block; }
a { color: inherit; text-decoration: none; }
button { font-family: inherit; cursor: pointer; }

/* Skip Link */
.skip-link {
  position: absolute;
  top: -100px;
  left: 50%;
  transform: translateX(-50%);
  padding: var(--sp-3) var(--sp-6);
  background: var(--c-primary);
  color: var(--c-on-primary, var(--c-white)); /* QA: A-3 */
  border-radius: var(--radius-md);
  font-weight: 600;
  z-index: 9999;
}
.skip-link:focus { top: var(--sp-4); }

/* Container */
.container {
  width: 100%;
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 0 calc(var(--container-padding) + var(--edge-width, 0px));
}

/* QA: VIS-2 — Section Header (refined) */
.section-header {
  text-align: center;
  margin-bottom: var(--density-grid-gap, var(--sp-12));
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}
.section-header h2 {
  font-family: var(--font-display);
  font-size: clamp(var(--text-2xl), 4vw, var(--text-3xl));
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-tight);
  line-height: var(--leading-tight);
  margin-bottom: var(--sp-3);
}
.section-header p {
  color: var(--c-text-light);
  font-size: var(--text-lg);
  line-height: var(--leading-body);
  max-width: 55ch;
  margin-left: auto;
  margin-right: auto;
}

/* ============================================
   BUTTONS
   ============================================ */

/* QA: VIS-3 — Buttons (upgraded) */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-2);
  padding: var(--sp-4) var(--sp-6);
  min-height: 48px;
  font-size: var(--text-base);
  font-weight: var(--weight-semibold);
  line-height: 1.15;
  border-radius: var(--btn-radius, var(--radius-md));
  border: 2px solid transparent;
  transition:
    transform var(--duration-fast) var(--ease-out),
    box-shadow var(--duration-fast) var(--ease-out),
    background var(--duration-fast) var(--ease-out),
    border-color var(--duration-fast) var(--ease-out);
  white-space: nowrap;
  cursor: pointer;
  position: relative;
}
.btn:disabled, .btn[aria-disabled="true"] {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.btn--primary {
  background: var(--btn-primary-bg, var(--c-primary));
  color: var(--btn-primary-color, var(--c-on-primary, var(--c-white)));
  border-color: var(--btn-primary-border, var(--c-primary));
  box-shadow: var(--shadow-sm);
}
.btn--primary:hover {
  background: var(--btn-primary-hover-bg, var(--c-primary-light));
  border-color: var(--btn-primary-hover-border, var(--c-primary-light));
  color: var(--btn-primary-hover-color, var(--btn-primary-color, var(--c-on-primary)));
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}
.btn--primary:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

.btn--secondary {
  background: transparent;
  color: var(--c-text);
  border-color: var(--c-border);
}
.btn--secondary:hover {
  border-color: var(--c-text);
  transform: translateY(-2px);
}

.btn--secondary-light {
  background: transparent;
  color: var(--c-white);
  border-color: rgba(255,255,255,0.3);
}
.btn--secondary-light:hover {
  border-color: var(--c-white);
  background: rgba(255,255,255,0.1);
  transform: translateY(-2px);
}

.btn--accent {
  background: var(--c-accent);
  color: var(--c-white);
  border-color: var(--c-accent);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.btn--accent:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(var(--c-accent-rgb), 0.3);
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: background 0.15s, border-color 0.15s;
  }
  .btn:hover {
    transform: none;
  }
}
`;
}
